'use client';

import { createContext, useContext } from 'react';

import type { ModalProps } from './modal.types';

const ModalContext = createContext<Pick<
  ModalProps,
  'closeModal' | 'isModalOpen' | 'openModal'
> | null>(null);

export const useModal = () => {
  const modal = useContext(ModalContext);

  if (modal === null)
    throw new Error('component must be wrapped in ModalProvider');

  return modal;
};

export const ModalProvider = ModalContext.Provider;
